import {
  ReportBrandingContactInterface,
  ReportBrandingImageSlot,
  ReportBrandingInterface
} from "../../common/interfaces";
import api from "../../services/api";

export interface UpsertReportBrandingPayload {
  cover_title?: string;
  cover_tagline_1?: string;
  cover_tagline_2?: string;
  accent_color?: string;
  about_title?: string;
  about_text?: string;
  support_title?: string;
  support_text?: string;
  site_url?: string;
  contacts?: ReportBrandingContactInterface[];
  show_cover?: boolean;
  show_about_page?: boolean;
  show_support_page?: boolean;
  show_index?: boolean;
  show_contacts_page?: boolean;
}

/**
 * Devolve null quando a empresa ainda não cadastrou nada — o Nest responde
 * 200 com corpo vazio nesse caso, que o axios entrega como string vazia.
 */
export async function fetchReportBranding(): Promise<ReportBrandingInterface | null> {
  const { data } = await api.get("/report-branding");
  return data && typeof data === "object" ? data : null;
}

export async function saveReportBranding(
  payload: UpsertReportBrandingPayload
): Promise<ReportBrandingInterface> {
  const { data } = await api.put("/report-branding", payload);
  return data;
}

export async function uploadReportBrandingImage(
  slot: ReportBrandingImageSlot,
  file: File
): Promise<ReportBrandingInterface> {
  const formData = new FormData();
  formData.append("image", file);
  const { data } = await api.post(`/report-branding/images/${slot}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
}

export async function removeReportBrandingImage(
  slot: ReportBrandingImageSlot
): Promise<ReportBrandingInterface> {
  const { data } = await api.delete(`/report-branding/images/${slot}`);
  return data;
}
